import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useSalesOrderActivities } from '@/hooks/api/1340_sales_order_activities';
import { ActivityRow } from '@/components/features/ActivityRow';
import { MotionDiv } from '@/components/element/MotionDiv';

export const Activities = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { data: activities } = useSalesOrderActivities({ identifier: _w_!.identifier, team_id: _t_!.id, id: _so_!.id });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">プロジェクトの変更履歴</h6>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="timeline timeline-one-side" data-timeline-axis-style="dotted">
          {activities?.map((d) => <ActivityRow key={`activity-${d.id}`} d={d} />)}
        </div>
      </div>
    </MotionDiv>
  );
};
